export default "__VITE_PUBLIC_ASSET__d974f140__"